export default __webpack_public_path__ + "static/media/Pilgrim's Straps of the Soaring God.dda54cd6.jpg";